// extracted by mini-css-extract-plugin
export default {"labsContainer":"LabsPage_labsContainer__lJIlo","form":"LabsPage_form__4tpKU","formGroup":"LabsPage_formGroup__Iu-q3"};